export { default } from './GroupIcon'
export * from './GroupIcon.styles'
